import { VehicleForm } from '@features/vehicles/components/VehicleForm';

export const VehicleStep = ({ form, onCirculationCityChange, cardProps }) => {
  return (
    <VehicleForm form={form} onCirculationCityChange={onCirculationCityChange} cardProps={cardProps} />
  );
};
